import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { requiredRule, urlRule } from '@utils/rules'
import { Form, Input, Switch } from 'antd'

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="serviceKey" rules={[]} label={'Service Key'}>
        <Input />
      </Form.Item>
      <Form.Item name="appId" rules={[requiredRule()]} label={'App ID'}>
        <Input />
      </Form.Item>
      <Form.Item name="secret" rules={[requiredRule()]} label={'Secret'}>
        <Input />
      </Form.Item>
      <Form.Item
        name="hostApi"
        rules={[requiredRule(), urlRule()]}
        label={'Host API'}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="hostExport"
        rules={[requiredRule(), urlRule()]}
        label={'Host Export'}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="isHq"
        label={'Is HQ ?'}
        valuePropName="checked"
        initialValue={false}
      >
        <Switch />
      </Form.Item>
      <Form.Item name="venue" label={'Venue'}>
        <SBAsyncSelect entity={Entity.venue} allowClear />
      </Form.Item>
    </Form>
  )
}

export default Create
